var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromotionExpired = function SvgPromotionExpired(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 157,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#promotionExpired_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E82A3A",
    d: "M0-3.5h295v187H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD6AA",
    d: "M63.427 80.06a19.34 19.34 0 0 0 11.427 11.427 19.34 19.34 0 0 0-11.427 11.426A19.34 19.34 0 0 0 52 91.487 19.34 19.34 0 0 0 63.427 80.06"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC0C1C",
    d: "m72.08 129.065-9.141-3.047c3.808-9.142 14.473-7.618 19.044-6.094-6.704 0-9.395 6.094-9.903 9.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F68E97",
    d: "m82.745 132.111 9.141 1.523c0-12.188-10.812-14.527-15.62-14.827 6.215 2.511 7.15 10.288 6.479 13.304"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC0C1C",
    d: "m233.092 40.133 5.536-5.6c-6.155-5.254-13.365-.201-16.133 2.599 4.886-2.478 9.101.968 10.597 3.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F68E97",
    d: "m226.446 46.297-6.099 4.49c-4.506-8.883 2.509-14.585 5.903-16.58-3.602 4.127-1.408 10.14.196 12.09"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.211,
    cy: 154.056,
    fill: "#CC0C1C",
    rx: 33.993,
    ry: 5.173
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40444D",
    strokeWidth: 5.912,
    d: "m170.762 122.541 13.229 26.535"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40444D",
    d: "m181.289 150.271-.689-1.376-4.576-22.26 15.108 25.381c.869 1.461-.616 3.19-2.191 2.551l-5.355-2.172a4.43 4.43 0 0 1-2.297-2.124"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40444D",
    strokeWidth: 5.912,
    d: "M151.922 122.931s-.745 4.781-.373 12.911c.373 8.129 2.014 16.35 2.014 16.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40444D",
    d: "m146.018 152.386 4.053-3.243 5.86-.521.796 4.592a1.478 1.478 0 0 1-1.444 1.73l-8.329.074c-1.403.012-2.032-1.755-.936-2.632"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40444D",
    strokeLinecap: "round",
    strokeWidth: 5.912,
    d: "m111.645 69.335 1.788.01a14.78 14.78 0 0 1 12.799 7.534l9.123 16.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB7722",
    d: "m206.59 67.898-58.837-6.184a1.457 1.457 0 0 0-1.601 1.296l-6.183 58.833c-.084.8.496 1.517 1.296 1.601l58.837 6.184c.8.084 1.516-.497 1.6-1.297l6.184-58.832a1.456 1.456 0 0 0-1.296-1.601"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD591",
    d: "m196.149 66.801-58.837-6.184a1.456 1.456 0 0 0-1.6 1.296l-6.184 58.833c-.084.8.496 1.517 1.296 1.601l58.837 6.184c.8.084 1.516-.496 1.6-1.296l6.184-58.833a1.456 1.456 0 0 0-1.296-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1251B",
    d: "M150.642 99.479c6.884 5.837 16.757 6.751 24.595 2.276l4.867 5.86c-11.12 7.043-25.683 5.695-35.322-3.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8A04B",
    d: "m172.762 64.343-11.759-1.236-.927 8.82 11.759 1.235z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#40444D",
    strokeLinecap: "round",
    strokeWidth: 5.912,
    d: "M199.946 95.519s2.614 14.118 5.912 18.221c3.298 4.104 6.253 4.843 6.253 4.843"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.926,
    cy: 45.428,
    r: 26.067,
    fill: "#CC0C1C",
    transform: "rotate(-15 105.926 45.428)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m95.52 58.48 15.091-26.245 6.003.005-15.09 26.246zm1.084-13.903a6.75 6.75 0 0 1-3.058-.71 6.26 6.26 0 0 1-2.216-1.954 4.9 4.9 0 0 1-.8-2.694l.001-1.583q0-1.11.46-2.087a5.2 5.2 0 0 1 1.34-1.715 7.2 7.2 0 0 1 2.067-1.177 6.4 6.4 0 0 1 2.218-.402q1.224 0 2.332.406 1.147.406 2.025 1.18a5.4 5.4 0 0 1 1.337 1.752 4.8 4.8 0 0 1 .457 2.055l-.001 1.582a4.9 4.9 0 0 1-.461 2.053A5.25 5.25 0 0 1 101.003 43l-.038.034q-1.837 1.547-4.36 1.544m.008-7.743a.95.95 0 0 0-.65.235q-.23.201-.23.572l-.002 1.582q0 .303.267.54a.9.9 0 0 0 .612.236q.459 0 .573-.135l.077-.067q.344-.303.344-.572l.002-1.582q0-.337-.305-.573-.268-.236-.688-.236m18.945 21.7a7.2 7.2 0 0 1-2.409-.407 5.8 5.8 0 0 1-1.949-1.18 5.2 5.2 0 0 1-1.298-1.719 5 5 0 0 1-.457-2.087l.002-1.549q0-1.078.46-2.053a5.4 5.4 0 0 1 1.34-1.75q1.722-1.58 4.322-1.578 2.372.002 4.32 1.553l.038.033q.84.776 1.298 1.752.459.977.457 2.054l-.001 1.55a4.7 4.7 0 0 1-.499 2.086 5.2 5.2 0 0 1-1.302 1.716q-1.722 1.581-4.322 1.578m.007-7.744q-.382 0-.688.235a.73.73 0 0 0-.268.572l-.002 1.548q0 .337.305.607v.033h.039q.19.17.611.17.422 0 .612-.168l.039-.034a.77.77 0 0 0 .268-.606l.001-1.548a.84.84 0 0 0-.267-.607h-.038q-.23-.202-.612-.202"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "promotionExpired_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h295v156H0z"
  })))));
};
export default SvgPromotionExpired;